module.exports = __webpack_public_path__ + "static/img/10.2f738c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/sp/10.png
// module id = U6kK
// module chunks = 0